import styled from "styled-components";
import IconOccupant from "./IconOccupant";


interface Props {
    n: number
}


const Room = ({ n }: Props) => {

    return (
        <Container className="box-en-ligne-occupant no-border">
            <IconOccupant />
            <Container className="container-occupant no-border">
                <ValueField className="no-border font-list">
                    {n}
                </ValueField>
                <Title className="no-border font-list">
                    {n == 1 ? "personne active" : "personnes actives"}
                </Title>
            </Container>
        </Container>
    );
};


const Container = styled.div`
    border: 3px solid;
    border-radius: 5px;
`

const Title = styled.div`
    padding: .5em;
    margin: 0;
`

const ValueField = styled.div`
    font-size: 1.875em;
    border-top: 2px solid;
`


export default Room;